<input
  type="file"
  #acsFileInputComponentElement
  hidden
  accept="{{ fileTypes }}"
  [multiple]="allowMultiple"
/>
<button mat-button (click)="standInClick()">
  @if (iconPosition === 'before') {
  <mat-icon class="fa-paperclip"></mat-icon>
  }
  {{ buttonText }}
  @if (iconPosition === 'after') {
  <mat-icon class="fa-paperclip"></mat-icon>
  }
</button>
